import { combineReducers } from "redux";

import courseSlice from "../modules/course";

export default combineReducers({
  course: courseSlice
});
